// 通用作业流程
import publicRequest from '@/plugin/axios/request-public.js';

// 获取token
export const getToken = (data) => publicRequest({
  url: '/vasCommon/public/app/h5/login',
  method: 'post',
  data
});

// 校验h5登录是否越权
export const h5Check = (data) => publicRequest({
  url: '/vas/app/query/h5/check',
  method: 'post',
  data
});

// 修改预约时间
export const updateAppointment = (data) => publicRequest({
  url: 'vas/app/operate/updateAppointment',
  method: 'post',
  data
});

// 拨打电话
export const callPhone = (data) => publicRequest({
  url: '/vas/app/operate/callPhone',
  method: 'post',
  data
});

// 校验作业人员在当前状态下是否拨打过电话
export const checkCallPhone = (data) => publicRequest({
  url: '/vas/app/operate/checkCallPhone',
  method: 'post',
  data
});

// 作业人员已出发
export const workerSetOut = (data) => publicRequest({
  url: '/vas/app/operate/workerSetOut',
  method: 'post',
  data
});

// 作业人员已达到
export const workerArrive = (data) => publicRequest({
  url: '/vas/app/operate/workerArrive',
  method: 'post',
  data
});

// 修改服务终点
export const updateDestination = (data) => publicRequest({
  url: '/vas/app/operate/updateDestination',
  method: 'post',
  data
});

// 获取影像模板
export const mediaTemplate = (data) => publicRequest({
  url: '/vas/app/operate/mediaTemplate',
  method: 'post',
  data
});

// 获取已上传的所有影像信息
export const getMediaDetail = (data) => publicRequest({
  url: '/vas/app/operate/getMediaDetail',
  method: 'post',
  data
});

// 保存影像
export const saveMedia = (data) => publicRequest({
  url: '/vas/app/operate/saveMedia',
  method: 'post',
  data
});

// 根据id删除影像
export const delMediaById = (data) => publicRequest({
  url: '/vas/app/operate/delMediaById',
  method: 'post',
  data
});

// 结束作业（当前任务状态为开始作业）
export const endWork = (data) => publicRequest({
  url: '/vas/app/operate/endWork',
  method: 'post',
  data
});

// 申诉里程
export const appealDistance = (data) => publicRequest({
  url: '/vas/app/operate/appealDistance',
  method: 'post',
  data
});

// 联系用户虚拟号次数
export const contactUserCount = (data) => publicRequest({
  url: '/vas/app/operate/contactUserCount',
  method: 'post',
  data
});

// 取消订单
export const cancel = (data) => publicRequest({
  url: '/vas/app/operate/cancel',
  method: 'post',
  data
});

// 重新提审
export const reAudit = (data) => publicRequest({
  url: '/vas/app/operate/reAudit',
  method: 'post',
  data
});

// 保存用户位置
export const saveTaskPosition = (data) => publicRequest({
  url: '/vas/app/operate/saveTaskPosition',
  method: 'post',
  data
});

// 作业人员上传增值产品
export const saveExtra = (data) => publicRequest({
  url: '/vas/app/operate/saveExtra',
  method: 'post',
  data
});

// 保存订单信息
export const appSaveInfo = (data) => publicRequest({
  url: '/vas/app/operate/appSaveInfo',
  method: 'post',
  data
});

// 我的账户详情
export const cashAccountDetail = (data) => publicRequest({
  url: '/vas/app/user/account/cashAccountDetail',
  method: 'post',
  data
});

// 根据分类查询文章
export const learningArticleTypes = (data) => publicRequest({
  url: '/vas/app/user/learningArticle/types',
  method: 'post',
  data
});
  // 根据分类查询文章
export const learningArticleQueryArticleByTypes = (data) => publicRequest({
  url: '/vas/app/user/learningArticle/queryArticleByTypes',
  method: 'post',
  data
});
// 根据分类查询文章
export const learningArticleQueryArticleDetail = (data) => publicRequest({
  url: '/vas/app/user/learningArticle/queryArticleDetail',
  method: 'post',
  data
});
// 阅读文章
export const learningArticleRead = (data) => publicRequest({
  url: '/vas/app/user/learningArticle/read',
  method: 'post',
  data
});

